import { StyleSheet, View } from "react-native";
import { fp, spH } from "utils/normalise";

import { Colors } from "colors";
import { CommonStyles } from "utils/CommonStyles";
import { FONTS_SIZES } from "fonts";
import React from "react";
import VText from "components/VText";
import { getFormatedCurrency } from "utils/common";
import { useSelector } from "react-redux";

const SaleComponent = ({
    originalPrice,
    discountPercentage,
    finalPrice,
    isCart = false,
    discountStyle = {},
    finalPriceStyle = {},
    originalPriceStyle = {},
}) => {
    const countrySymbol = useSelector((state) => state.StoredutilsSlice.countrySymbol);
    return (
        <>
            <View style={styles.container}>
                <VText
                    text={`${countrySymbol}${getFormatedCurrency(originalPrice)}`}
                    style={[
                        {
                            fontSize: fp(16),
                            lineHeight: fp(24),
                            textDecorationLine: "line-through",
                            color: "black",
                            marginRight: spH(10),
                        },
                        originalPriceStyle,
                    ]}
                />
                <VText style={[CommonStyles.subHeadingText15, discountStyle]}>{discountPercentage}% off</VText>
            </View>
            <VText
                style={[
                    CommonStyles.subHeadingText15,
                    {
                        color: Colors.red,
                        fontWeight: isCart ? "700" : "400",
                        textAlign: isCart ? "right" : "left",
                    },
                    finalPriceStyle,
                ]}
            >
                {`${countrySymbol}${getFormatedCurrency(finalPrice)}`}
            </VText>
        </>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
    },
    originalPrice: {
        fontSize: fp(16),
        textDecorationLine: "line-through",
        color: "black",
        marginRight: spH(10),
    },
});

export default SaleComponent;
